export enum SeaEventTypeEnum {
    AdjustHoursAfterTimeZoneChange = 148,
    IDLCrossing = 147,
}
